import React from 'react'
import logo from './logo.png'
import './MyMoney.css'

export default function MyMoney() {
  return (
    <div className='contenedor_logo' >
      <img className='logo' src={logo} alt="Imagen fajo de billetes con alas" />
      <p className='MyMoney'>MyMoney</p>
    </div>
  )
}